// Create the parser instance once at module level to avoid overhead in loops
let parser: DOMParser | null = null;

if (typeof window !== "undefined" && window.DOMParser) {
  parser = new DOMParser();
}

/**
 * Decodes HTML entities in a string (e.g. "Indoor&#038;Outdoor" -> "Indoor&Outdoor").
 * Highly optimized to reuse the parser instance.
 *
 * @param text The string containing HTML entities.
 * @returns The decoded string.
 */
export const decodeHtmlEntities = (text: string | undefined | null): string => {
  if (!text) return "";

  // 1. Apex path: If no ampersand, no entities to decode.
  if (text.indexOf("&") === -1) return text;

  // 2. DOMParser approach (Most robust for all entities)
  if (parser) {
    try {
      const doc = parser.parseFromString(text, "text/html");
      return doc.documentElement.textContent || text;
    } catch (e) {
      return text;
    }
  }

  // 3. Fallback for SSR or environments without DOMParser (Basic replacement)
  return text
    .replace(/&amp;|&#038;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#039;/g, "'");
};
